interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  variant?: 'default' | 'dots' | 'pulse';
}

export function LoadingSpinner({ size = 'md', className = '', variant = 'default' }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  };

  const baseSizeClass = sizeClasses[size];

  if (variant === 'dots') {
    const dotSize = {
      sm: 'h-1 w-1',
      md: 'h-1.5 w-1.5',
      lg: 'h-2 w-2'
    }[size];

    return (
      <div className={`flex space-x-1 ${className}`}>
        <div className={`${dotSize} bg-primary-600 rounded-full animate-bounce`} style={{ animationDelay: '0ms' }} />
        <div className={`${dotSize} bg-primary-600 rounded-full animate-bounce`} style={{ animationDelay: '150ms' }} />
        <div className={`${dotSize} bg-primary-600 rounded-full animate-bounce`} style={{ animationDelay: '300ms' }} />
      </div>
    );
  }

  if (variant === 'pulse') {
    return (
      <div className={`${baseSizeClass} bg-primary-200 rounded-full animate-pulse ${className}`} />
    );
  }

  // Default spinning circle
  return (
    <div className={`animate-spin rounded-full border-2 border-gray-300 border-t-primary-600 ${baseSizeClass} ${className}`} />
  );
}